import React, { useState,useRef } from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import { QRCodeCanvas } from 'qrcode.react';
import { Helmet } from 'react-helmet'


export default function Qr() {
  let [text,setText]=useState("");
  let [Visible,setVisible]=useState(false);
  let [rotate,setRotate]=useState(false);
  let qrRef = useRef(null);


  let downloadQr = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;
  
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
  
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qr-code.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  

  let textSet=(e)=>{
    setText(text=e.target.value);
    setVisible(false);
  }
  let generateQr=()=>{
    setRotate(true);
    setTimeout(() => {
      setRotate(false);
      setVisible(Visible=true);
    }, 1000);

   
    
  }

    return (
    <div className="outerQr">
    <Helmet>
  <html lang="en" />
  <title>Free QR Code Generator – Create Custom QR Codes | Tooliso</title>
  <meta
    name="description"
    content="Create custom QR codes for URLs, contact info, WiFi access, and more in seconds. Fast, free, and no installation required."
  />
  <link rel="canonical" href="https://tooliso.com/qr" />

  <meta property="og:title" content="Free QR Code Generator – Tooliso" />
  <meta
    property="og:description"
    content="Generate high-quality, scannable QR codes instantly with Tooliso’s free QR Code Generator. Perfect for websites, events, and more."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://tooliso.com/qr" />

  <meta name="twitter:card" content="summary" />
  <meta name="twitter:title" content="Tooliso QR Code Generator – Fast & Free" />
  <meta
    name="twitter:description"
    content="Create QR codes for links, contacts, and more using Tooliso’s quick and easy online generator."
  />
</Helmet>

          <Header />
       <Header />
      <div className="qrCode">
      <div className="innerQr">
        <h1>QR Code Generator</h1>
        <p>Generate your own QR codes for free! Enter any text or link and download your QR code image. Simply enter the text or URL you want to encode, and click "Generate". Once generated, you can download the QR code image for your use. It's that easy!</p>
        <textarea placeholder='Enter any link or text...' value={text} onChange={(e)=>textSet(e)}></textarea>
        <button onClick={generateQr}>Generate</button>
        {
          rotate?
          <div className='rotate'></div>:""
        }
        {
          Visible?
                <div className="qr" ref={qrRef}>
                  <QRCodeCanvas value={text} size={224} />
                  <button onClick={downloadQr}>Download Qr</button>
                </div>
         :""
        }

      </div>
    </div>
    <Footer/>
    </div>
  )
}
